// All functions are pure; no React, no i18n. UI maps levels -> labels/colors.

export const POSITION_LEVELS = ['lowest', 'same', 'low', 'average', 'high', 'highest'];

export function pricePosition(row) {
  const { price, competitorsMinPrice: min, competitorsMaxPrice: max } = row || {};
  if (price == null || price <= 0 || min == null || max == null) return null;
  // 'same' = tied with the cheapest competitor (my price equals the min).
  if (price <= min) return { level: price < min ? 'lowest' : 'same', frac: bandPosition(price, min, max) };
  if (price >= max) return { level: 'highest', frac: bandPosition(price, min, max) };
  // In between: mid of the band is 'average', otherwise below/above average.
  const frac = bandPosition(price, min, max);
  return { level: frac < 0.4 ? 'low' : (frac > 0.6 ? 'high' : 'average'), frac };
}

export function bandPosition(value, min, max) {
  if (max === min) {
    if (value > min) return 1;   // above the single competitor price -> right
    if (value < min) return 0;   // below -> left
    return 0.5;                  // exactly equal -> middle
  }
  const f = (value - min) / (max - min);
  return Math.max(0, Math.min(1, f));
}

export function suggestionAction(row) {
  const { price, suggested_price: s } = row || {};
  if (s == null || price == null || price <= 0 || s === price) return null;
  const delta = +(s - price).toFixed(2);
  return { dir: delta > 0 ? 'up' : 'down', value: s, delta };
}

export function profitLoss(row) {
  const { price, drop_shipping_cost: cost } = row || {};
  if (price == null || cost == null) return null;
  return { loss: price < cost, margin: +(price - cost).toFixed(2) };
}

export function violations(row) {
  const vs = (row && row.violation_strategy) || {};
  const map = vs.min_value;
  const mrp = vs.max_value;
  const { competitorsMinPrice: min, competitorsMaxPrice: max } = row || {};
  return {
    map: map != null && min != null && min < map,
    mrp: mrp != null && max != null && max > mrp,
  };
}

export function mapValue(row) { return row && row.violation_strategy ? row.violation_strategy.min_value : null; }
export function mrpValue(row) { return row && row.violation_strategy ? row.violation_strategy.max_value : null; }
